import React, { useContext } from "react";
import "./CSS/ShopCategory.css";
import Item from "../Components/Item/Item";
import { ShopContext } from "../Context/ShopContext";
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import ShopStatusBanner from '../Components/ShopStatusBanner/ShopStatusBanner'; 
import InstagramCTA from '../Components/InstagramCTA/InstagramCTA.jsx';

const ItemSkeleton = () => {
    return (
        <SkeletonTheme baseColor="#fdeadc" highlightColor="#fef5ee">
            <div className="item-card-skeleton">
                <Skeleton height="100%" style={{ aspectRatio: '1/1' }} />
                <div className="item-card-details-skeleton">
                    <Skeleton width="80%" />
                    <Skeleton width="40%" />
                </div>
            </div>
        </SkeletonTheme>
    );
};

const ShopCategory = (props) => {
    const { all_products, loading, shopStatus } = useContext(ShopContext);
    const categoryItems = all_products.filter(item => props.category === item.category);

    return (
        <div className="shop-category-page">
            <div 
                className="shop-category-hero" 
                style={{ backgroundImage: `url(${props.banner})` }}
            >
                <div className="hero-overlay"></div>
                <div className="hero-content container">
                    {/* Hero content can be added back here if desired */}
                </div>
            </div>

            <ShopStatusBanner status={shopStatus} loading={loading}/>
            
            <div id="menu-section" className="shop-category-layout container">
                <div className="product-grid">
                    {loading ? (
                        Array.from({ length: 4 }).map((_, index) => <ItemSkeleton key={index} />)
                    ) : (
                        categoryItems.map((item) => <Item key={item._id} data={item} />)
                    )}
                </div>
            </div>
            <InstagramCTA />
        </div>
    );
};

export default ShopCategory;